/**
 * HTML5 video preview + basic file info (name, size, duration).
 */
import React, { useEffect, useRef, useState } from 'react';

function formatBytes(bytes) {
  if (!bytes) return '0 B';
  const units = ['B', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(1024));
  return `${(bytes / 1024 ** i).toFixed(1)} ${units[i]}`;
}

function formatDuration(seconds) {
  if (!seconds) return '—';
  const m = Math.floor(seconds / 60);
  const s = Math.round(seconds % 60);
  return `${m}:${String(s).padStart(2, '0')}`;
}

export default function VideoPreview({ file, videoRef: externalRef, src }) {
  const internalRef = useRef(null);
  const videoRef = externalRef || internalRef;
  const [duration, setDuration] = useState(null);
  const objectUrl = useRef(null);

  useEffect(() => {
    if (!file) return undefined;
    objectUrl.current = URL.createObjectURL(file);
    return () => {
      if (objectUrl.current) URL.revokeObjectURL(objectUrl.current);
    };
  }, [file]);

  return (
    <div className="bg-white rounded-xl border border-gray-200 shadow-card overflow-hidden">
      <video
        ref={videoRef}
        src={src || objectUrl.current}
        controls
        className="w-full max-h-[420px] bg-black"
        onLoadedMetadata={(e) => setDuration(e.target.duration)}
      />
      {file && (
        <div className="p-4 grid grid-cols-3 gap-3 text-sm">
          <div>
            <p className="text-gray-400">File name</p>
            <p className="font-medium truncate">{file.name}</p>
          </div>
          <div>
            <p className="text-gray-400">Size</p>
            <p className="font-medium">{formatBytes(file.size)}</p>
          </div>
          <div>
            <p className="text-gray-400">Duration</p>
            <p className="font-medium">{formatDuration(duration)}</p>
          </div>
        </div>
      )}
    </div>
  );
}
